<div class="p-3">
  <h3>Inter-company Adjustment</h3>
  <p>Record one company Bank out and another company Bank in. Same currency only. This records the ledger movement; it does not send money through a bank.</p>
  <div class="alert alert-danger" role="alert" *ngIf="error">{{error}}</div>
  <div class="alert alert-success" role="status" *ngIf="message">{{message}}</div>
  <p *ngIf="loading">Loading…</p>
  <p *ngIf="!loading && companies.length < 2">You need Bank Adjustment permission and assignment in at least two active companies.</p>
  <form (ngSubmit)="submit()">
    <fieldset [disabled]="busy || !!pending || loading">
      <div class="row g-3">
        <div class="col-md-6">
          <label for="ic-from">From Company (Out)</label>
          <select id="ic-from" class="form-select" name="from" [(ngModel)]="data.from_company" (ngModelChange)="data.from_bank=null" required>
            <option [ngValue]="undefined">Select company</option>
            <option *ngFor="let c of companies" [value]="c.uuid">{{c.name}} — {{c.currency || 'Currency not configured'}}</option>
          </select>
          <label for="ic-from-bank">From Bank</label>
          <select id="ic-from-bank" class="form-select" name="fromBank" [(ngModel)]="data.from_bank" required>
            <option [ngValue]="null">Select bank</option>
            <option *ngFor="let b of from?.banks" [ngValue]="b.id">{{b.title}} / {{b.payee}} / {{b.account}}</option>
          </select>
          <p *ngIf="fromBank">Balance: {{fromBank.balance | number:'1.2-2'}} → {{(+fromBank.balance - amount) | number:'1.2-2'}}</p>
        </div>
        <div class="col-md-6">
          <label for="ic-to">To Company (In)</label>
          <select id="ic-to" class="form-select" name="to" [(ngModel)]="data.to_company" (ngModelChange)="data.to_bank=null" required>
            <option [ngValue]="undefined">Select company</option>
            <option *ngFor="let c of companies" [value]="c.uuid" [disabled]="c.uuid === data.from_company">{{c.name}} — {{c.currency || 'Currency not configured'}}</option>
          </select>
          <label for="ic-to-bank">To Bank</label>
          <select id="ic-to-bank" class="form-select" name="toBank" [(ngModel)]="data.to_bank" required>
            <option [ngValue]="null">Select bank</option>
            <option *ngFor="let b of to?.banks" [ngValue]="b.id">{{b.title}} / {{b.payee}} / {{b.account}}</option>
          </select>
          <p *ngIf="toBank">Balance: {{toBank.balance | number:'1.2-2'}} → {{(+toBank.balance + amount) | number:'1.2-2'}}</p>
        </div>
      </div>
      <p *ngIf="from && to && from.currency !== to.currency" class="text-danger">Currencies must match.</p>
      <label for="ic-amount">Amount</label>
      <input id="ic-amount" class="form-control" type="number" min="0.01" step="0.01" name="amount" [(ngModel)]="data.amount" required>
      <label for="ic-reason">Reason</label>
      <input id="ic-reason" class="form-control" name="reason" maxlength="500" [(ngModel)]="data.remark" required>
      <p class="small">Balance previews may change before submission. Negative ledger balances are allowed, as with existing adjustments.</p>
      <button class="btn btn-primary my-2" type="submit" [disabled]="!valid">Confirm Adjustment</button>
    </fieldset>
  </form>
  <div *ngIf="pending && !busy" class="alert alert-warning">The request has not been confirmed. Retry safely with the same reference key.
    <button class="btn btn-warning" (click)="send()">Retry same request</button>
  </div>
  <hr>
  <h4>Consolidated Adjustment History</h4>
  <p>Only transfers for which you have access to both companies are shown. Reversals remain as separate opposite entries. The report totals below use the full date range, across all pages.</p>
  <div class="d-flex flex-wrap gap-2 align-items-end">
    <label>Company<select class="form-select" [(ngModel)]="filter.company"><option value="">All Companies</option><option *ngFor="let c of companies" [value]="c.uuid">{{c.name}}</option></select></label>
    <label>Date From<input class="form-control" type="date" [(ngModel)]="filter.date_from"></label>
    <label>Date To<input class="form-control" type="date" [(ngModel)]="filter.date_to"></label>
    <button class="btn btn-secondary" (click)="loadHistory()" [disabled]="loading || busy">Search</button>
  </div>
  <table class="table mt-3">
    <thead><tr><th>Company</th><th>Currency</th><th>Inter-company In</th><th>Inter-company Out</th><th>Net</th></tr></thead>
    <tbody><tr *ngFor="let s of history.summary"><td>{{s.company}}</td><td>{{s.currency}}</td><td>{{s.incoming | number:'1.2-2'}}</td><td>{{s.outgoing | number:'1.2-2'}}</td><td>{{s.net | number:'1.2-2'}}</td></tr></tbody>
  </table>
  <div class="table-responsive"><table class="table">
    <thead><tr><th>Date / Reference</th><th>From (Out)</th><th>To (In)</th><th>Amount</th><th>Reason / Status</th><th></th></tr></thead>
    <tbody><tr *ngFor="let row of history.collection">
      <td>{{row.timestamp}}<br>{{row.reference}}</td><td>{{row.from_company}}<br>{{row.from_bank}}</td><td>{{row.to_company}}<br>{{row.to_bank}}</td>
      <td>{{row.currency}} {{row.amount | number:'1.2-2'}}</td><td>{{row.remark}}<br><span *ngIf="row.reversal_of">Reversal of {{row.reversal_of}}</span><span *ngIf="row.reversed_by">Reversed by {{row.reversed_by}}</span></td>
      <td><button class="btn btn-outline-danger btn-sm" *ngIf="!row.reversal_of && !row.reversed_by" [disabled]="busy || !!pending" (click)="reverse(row)">Reverse entire transfer</button></td>
    </tr></tbody>
  </table></div>
  <p *ngIf="!history.collection.length && !loading">No transfers in this date range.</p>
  <button class="btn btn-secondary" [disabled]="loading || history.page <= 1" (click)="loadHistory(history.page-1)">Previous</button>
  <span class="mx-2">Page {{history.page}} · {{history.total}} records</span>
  <button class="btn btn-secondary" [disabled]="loading || history.page*50 >= history.total" (click)="loadHistory(history.page+1)">Next</button>
</div>
